import axios from './axios'

class ProductRepository {
  getAll () {
    return axios.get('/products').then(response => response.data)
  }

  getBySlug (slug) {
    return axios.get(`/products/${slug}`).then(response => response.data)
  }

  createOrder (data) {
    return axios.post('/product-orders/create', data).then(response => response.data)
  }

  captureOrder (orderId) {
    return axios.get(`/product-orders/${orderId}/capture`).then(response => response.data)
  }

  getUserOrders () {
    return axios.get('/product-orders/user').then(response => response.data)
  }

  getOrder (orderId) {
    return axios.get(`/product-orders/${orderId}`).then(response => response.data)
  }
}

export default new ProductRepository()



// WEBPACK FOOTER //
// ./src/data/product.repository.js